import React, { useEffect } from 'react';
export function SplashScreen({
  onContinue
}: {
  onContinue?: () => void;
}) {
  useEffect(() => {
    const t = setTimeout(() => onContinue?.(), 1800);
    return () => clearTimeout(t);
  }, [onContinue]);
  return <div className="relative flex flex-col w-full h-full overflow-hidden" style={{
    background: 'linear-gradient(135deg, #00B5E0 0%, #009AC7 50%, #006D8C 100%)'
  }} role="img" aria-label="Regional Development Bank" data-id="element-641">
      {/* Status bar (light) */}
      <div className="relative h-[44px] w-full flex items-center justify-between px-6 text-white text-[15px] font-semibold tracking-tight" data-id="element-642">
        <span data-id="element-643">9:41</span>
        <div className="flex items-center gap-1.5" aria-hidden="true" data-id="element-644">
          <div className="flex items-end gap-[2px] h-3" data-id="element-645">
            <span className="w-[3px] h-[4px] bg-white rounded-[1px]" data-id="element-646" />
            <span className="w-[3px] h-[6px] bg-white rounded-[1px]" data-id="element-647" />
            <span className="w-[3px] h-[8px] bg-white rounded-[1px]" data-id="element-648" />
            <span className="w-[3px] h-[10px] bg-white rounded-[1px]" data-id="element-649" />
          </div>
          <svg width="16" height="12" viewBox="0 0 16 12" fill="none" data-id="element-650">
            <path d="M8 11.2a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4z" fill="#fff" data-id="element-651" />
            <path d="M3.5 6.8a6.4 6.4 0 019 0" stroke="#fff" strokeWidth="1.4" strokeLinecap="round" data-id="element-652" />
            <path d="M1 4.3a10 10 0 0114 0" stroke="#fff" strokeWidth="1.4" strokeLinecap="round" data-id="element-653" />
          </svg>
          <div className="flex items-center" data-id="element-654">
            <div className="w-[22px] h-[11px] rounded-[3px] border border-white/90 flex items-center p-[1px]" data-id="element-655">
              <div className="h-full w-[16px] bg-white rounded-[1.5px]" data-id="element-656" />
            </div>
            <div className="w-[1.5px] h-[4px] bg-white/90 ml-[1px] rounded-r-[1px]" data-id="element-657" />
          </div>
        </div>
      </div>

      {/* Centered logo */}
      <div className="flex-1 flex items-center justify-center px-8" data-id="element-658">
        <img src="https://cdn.magicpatterns.com/uploads/hQ7ApaF4xiNiw163CPigEQ/Regional_Development_Bank_idsJM_iVUg_2.jpg" alt="" className="rounded-full" style={{
        width: 240,
        height: 240,
        objectFit: 'cover'
      }} data-id="element-659" />
      </div>

      <div className="flex justify-center pb-2" data-id="element-660">
        <div className="w-[120px] h-[5px] rounded-full bg-white/80" aria-hidden="true" data-id="element-661" />
      </div>
    </div>;
}